import React, { useEffect, useState } from "react";
import { ChevronRight, Upload, Download, Eye, X, ChevronLeft, Trash2, Lock, AlertTriangle, Save } from "lucide-react";
import "../../styles/upload.css";
import { useNavigate, useLocation } from "react-router-dom";
import { useRef } from "react";
import Firstphoto from "../../assets/uploadpage1.png";
import Scoundphoto from "../../assets/uploadpage2.png";
import { IoClose } from "react-icons/io5";
import OMRPDF from "../../assets/omrimages/OMRPDF.png";
import OMR_20 from "../../assets/omrimages/20-OMR-EMPTY-Q.png";
import OMR_50 from "../../assets/omrimages/50-OMR-EMPTY-Q.png";
import OMR_100 from "../../assets/omrimages/100-OMR-EMPTY-Q.png";
import OMR_150 from "../../assets/omrimages/150-OMR-EMPTY-Q.png";
import OMR_200 from "../../assets/omrimages/200-OMR-EMPTY.png";
import { useDispatch, useSelector } from "react-redux";
import {
  masterdata_create,
  masterdata_list,
  students_profile,
  institution_dashboard,
  batch_create,
  update_profile,
  masterdata_update,
  user_exams_add,
} from "../../util/Apiendpoits";
import {
  deleteWithTokenAPI,
  deleteWithTokenAPIpayload,
  getWithoutTokenAPI,
  getWithTokenAPI,
  ImageUpload,
  postWithoutTokenAPI,
  postWithTokenAPI,
  putWithTokenAPI,
} from "../../util/Api";
import { FiBook, FiX } from "react-icons/fi";
import Select from "react-select";
import { SafeToast } from "../Toast/ShowToast";
import SelectDropdown from "../ReusableComponent/SelectDropdown";
import { setProfileData } from "../../store/profileSlice";

const UploadPage = () => {
  const location = useLocation();
  const isReturningFromOMR = location.state?.activeTab === "questions";
  const isEditingTest = Boolean(location.state?.editBatchName);

  // Clear local storage on initial mount if not returning from OMR sheet configuration or editing from batch details
  if (!isReturningFromOMR && !isEditingTest) {
    localStorage.removeItem("uploadFormData");
    localStorage.removeItem("totalQuestions");
    localStorage.removeItem("omrAnswers");
    localStorage.removeItem("allOmrAnswers");
    localStorage.removeItem("testBatches");
    localStorage.removeItem("numberOfTesting");
    localStorage.removeItem("currentTestIndex");
  }

  const [tab, setTab] = useState(() => {
    // if (location.state?.activeTab) {
    //     return location.state.activeTab;
    // }
    const saved = localStorage.getItem("uploadFormData");
    return saved ? "headline" : "headline";
  });
  const [totalQuestions, setTotalQuestions] = useState(() => {
    const saved = localStorage.getItem("totalQuestions");
    return saved ? parseInt(saved) : 0;
  });

  const [answers, setAnswers] = useState(() => {
    const saved = localStorage.getItem("omrAnswers");
    return saved ? JSON.parse(saved) : {};
  });


  const navigate = useNavigate();
  const profile = useSelector((state) => state.profile);
  const { token, roleType, userId } = useSelector((state) => state.auth);
  const [examOptions, setExamOptions] = useState([]);
  const [allexamOptions, setAllExamOptions] = useState([]);

  const [allSubexamOptions, setSubAllExamOptions] = useState([]);
  const [subExamOptions, setSubExamOptions] = useState([]);
  const [Institutionprofile, setInstitutionprofile] = useState(null);
  
  const [lastUpdatedQuestions, setLastUpdatedQuestions] = useState(0);


  console.log(lastUpdatedQuestions,"lastUpdatedQuestions")
  const [openDialog, setOpenDialog] = useState(false);
  const [showAddInput, setShowAddInput] = useState(false);
  const [newExamValue, setNewExamValue] = useState("");
  const dispatch = useDispatch();
  const [examName, setExamName] = useState("");
  const isExam = examName?.toLowerCase().trim() === "exam";
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState(() => {
    const savedFormData = localStorage.getItem("uploadFormData");
    if (savedFormData) {
      return JSON.parse(savedFormData);
    }
    return {
      headlineTagline: "",
      bannerTagline: "",
      testFees: "",
      testBatchName: "",
      subTopic: "",
      syllabus: "",
      schedulePdf: "",
      testNo: "1",
      questionPdf: "",
      answerPdf: "",
      videoLink: "",
      omrsheet: "",
      examduration: ""
    };
  });

  const [batchOptions, setBatchOptions] = useState([]);
  const [isExistingBatch, setIsExistingBatch] = useState(false);
  const [showDeleteBatchModal, setShowDeleteBatchModal] = useState(false);
  const [isDeletingBatch, setIsDeletingBatch] = useState(false);
  const [showIncreaseTestModal, setShowIncreaseTestModal] = useState(false);
  const [pendingTestCountData, setPendingTestCountData] = useState(null);
  const getParsedItem = (key) => {
    try {
      const item = localStorage.getItem(key);
      return item ? JSON.parse(item) : null;
    } catch (err) {
      console.warn(`Invalid JSON in localStorage for ${key}`);
      localStorage.removeItem(key); // cleanup bad data
      return null;
    }
  };

  const [activeExam, setActiveExam] = useState(() =>
    getParsedItem("activeExam"),
  );

  const [activeSubExam, setActiveSubExam] = useState(() =>
    getParsedItem("activeSubExam"),
  );

  useEffect(() => { }, [profile]);
  useEffect(() => {
    if (activeExam !== null) {
      localStorage.setItem("activeExam", JSON.stringify(activeExam));
    }
  }, [activeExam]);

  useEffect(() => {
    if (activeSubExam !== null) {
      localStorage.setItem("activeSubExam", JSON.stringify(activeSubExam));
    }
  }, [activeSubExam]);

  // Dashboard stats
  const [dashboardStats, setDashboardStats] = useState({
    totalStudents: 0,
    totalBatches: 0,
  });

  const [loading, setLoading] = useState(false);
  const [draftLoading, setDraftLoading] = useState(false);
  const tabsRef = useRef(null);
  const ExamtabsRef = useRef(null);
  const prevTestNoRef = useRef("");


  const handleRemovePdf = (field) => {
    setFormData((prev) => ({
      ...prev,
      [field]: null
    }));
  };



  const fetchExamOptions = async () => {
    try {
      const response = await getWithoutTokenAPI(masterdata_list);

      if (response.statusCode === 200) {
        const options = response.data
          .filter(
            (item) => item.type === "examType" && item.status === "active",
          )
          .map((item) => ({
            value: item.code,
            label: item.value,
            id: item._id,
          }));
        setAllExamOptions(options);

        const Suboptions = response.data
          .filter(
            (item) => item.type === "subexamType" && item.status === "active",
          )
          .map((item) => ({
            value: item.code,
            label: item.value,
            id: item._id,
          }));
        setSubAllExamOptions(Suboptions);
      }
    } catch (error) {
      console.error("Error fetching exam options:", error);
    }
  };

  useEffect(() => {
    fetchExamOptions();
  }, []);

  useEffect(() => {
    localStorage.setItem("uploadFormData", JSON.stringify(formData));
  }, [formData]);

  // Save total questions to localStorage
  useEffect(() => {
    localStorage.setItem("totalQuestions", totalQuestions);
  }, [totalQuestions]);

  // Save answers to localStorage
  useEffect(() => {
    localStorage.setItem("omrAnswers", JSON.stringify(answers));
  }, [answers]);

  // Fetch institution profile
  useEffect(() => {
    if (roleType !== "institution_admin") return;
    const fetchProfile = async () => {
      try {
        const updateRes = await getWithTokenAPI(
          token,
          `${students_profile}${userId}`,
        );

        if (updateRes?.statusCode === 200) {
          setInstitutionprofile(updateRes.data);
        }
      } catch (error) {
        console.log("Failed to load institution profile");
        SafeToast.error("Failed to load profile");
      }
    };

    fetchProfile();
  }, [roleType, token, userId]);



  const fetchBatchNames = async () => {
    try {

      if (!Institutionprofile?._id) return;

      const response = await getWithTokenAPI(
        token,
        `/batch/get-all?Institution_id=${Institutionprofile._id}&BatchNames=true&examType=${activeExam.value}`
      );


      if (response?.statusCode === 200) {

        // API ARRAY
        const batchArray = response?.data?.data || [];

        // REMOVE EMPTY OBJECTS + DUPLICATES
        const uniqueBatches = [
          ...new Map(
            batchArray
              .filter((item) => item?.testBatchName)
              .map((item) => [
                item.testBatchName,
                {
                  label: item.testBatchName,
                  value: item.testBatchName,
                },
              ])
          ).values(),
        ];

        console.log(uniqueBatches, "uniqueBatches");

        setBatchOptions(uniqueBatches);
      }

    } catch (err) {
      console.log(err);
    }
  };

  const editHandledRef = useRef(false);

  // CALL WHEN EXAM CHANGES
  useEffect(() => {
    fetchBatchNames();
    if (!location.state?.editBatchName || editHandledRef.current) {
      setFormData((prev) => ({
        ...prev,
        testBatchName: "",
      }));
      setIsExistingBatch(false);
      setTests([
        {
          testNo: "",
          totalQuestions: "",
          questionPdf: null,
          omrsheet: null,
          videoLink: "",
          isPublished: false,
          isDraft: false,
        },
      ]);
    }
  }, [activeExam, Institutionprofile]);

  const fetchUserExams = async () => {
    try {
      const response = await getWithTokenAPI(token, `/user/${userId}/exams`);

      if (response?.statusCode === 200) {
        const examOpts = response.data.exams.map((exam) => ({
          value: exam._id,
          label: exam.value,
          code: exam.code,
          id: exam._id,
        }));
        setExamOptions(examOpts);

        const subExamOpts = response.data.subexams.map((subexam) => ({
          value: subexam._id,
          label: subexam.value,
          parentCode: subexam.code,
          id: subexam._id,
        }));
        setSubExamOptions(subExamOpts);
      }
    } catch (error) {
      console.error("Error fetching user exams:", error);
      SafeToast.error("Failed to load exams");
    }
  };
  useEffect(() => {
    if (!userId) return;
    fetchUserExams();
  }, [userId, token]);

  // Fetch dashboard statistics
  const fetchDashboardStats = async () => {
    try {
      const response = await getWithTokenAPI(
        token,
        `${institution_dashboard}${userId}`,
      );

      if (response?.success) {
        setDashboardStats({
          totalStudents: response.data?.totalStudents || 0,
          totalBatches: response.data?.totalBatches || 0,
        });
      }
    } catch (error) {
      console.error("Error fetching dashboard stats:", error);
      SafeToast.error("Failed to load dashboard statistics");
    }
  };
  useEffect(() => {
    if (roleType !== "institution_admin" || !userId) return;

    fetchDashboardStats();
  }, [roleType, token, userId]);

  const handleAddExam = async () => {
    if (!newExamValue) {
      SafeToast.success("Exams Updated successfully!");
      setShowAddInput(false);
      setOpenDialog(false);
      return null;
    }
    const newExam = {
      code:
        examName === "exam" ? allSubexamOptions.length + 1 : activeExam.code,
      value: newExamValue,
      type: examName === "exam" ? "examType" : "subexamType",
      status: "active",
    };

    try {
      const response = await postWithoutTokenAPI(masterdata_create, newExam);
      if (response.statusCode === 200 || response.statusCode === 201) {
        const option = {
          value: response.data?._id || newExam.code,
          label: newExam.value,
          code: newExam.code,
        };
        fetchExamOptions();
        if (examName == "exam") {
          setAllExamOptions((prev) => [...prev, option]);
        } else {
          setSubExamOptions((prev) => {
            const relatedSubs = prev.filter(
              (sub) => sub.parentCode === activeExam.code,
            );
            const exists = relatedSubs.some(
              (sub) => sub.value === option.value,
            );

            if (exists) {
              return prev.filter((sub) => sub.value !== option.value);
            } else {
              const newOption = {
                ...option,
                parentCode: activeExam.code,
              };

              return [...prev, newOption];
            }
          });
        }

        setNewExamValue("");
        setShowAddInput(false);
        SafeToast.success("New exam added successfully!");
      }
    } catch (error) {
      console.error("Error creating new exam:", error);
      SafeToast.error("Failed to add new exam");
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const uploadFile = async (type, file) => {
    // const MAX_SIZE = 50 * 1024 * 1024; 

    // if (file.size > MAX_SIZE) {
    //   SafeToast.error("Maximum allowed PDF size is 45 MB");
    //   return null;
    // }
    const formData = new FormData();
    formData.append("files", file);

    try {
      const response = await ImageUpload(
        `/upload_image?userId=${userId}&type=${roleType}`,
        formData,
        true,
      );
      if (response.statusCode === 413) {
        SafeToast.error("Maximum allowed PDF size is 45 MB");
      }
      if (response.statusCode === 200) {
        return response?.data?.[0]?.fileUrl || null;
      }

    }
    catch (error) {
      SafeToast.error("Maximum allowed PDF size is 45 MB");
      return null;
    }
  };

  const handleFileUpload = async (fileType, file) => {
    const fileUrl = await uploadFile(fileType, file);

    if (!fileUrl) return;

    setFormData((prev) => ({
      ...prev,
      [fileType]: {
        name: file.name,
        url: fileUrl,
      },
    }));

    setErrors((prev) => {
      const updatedErrors = { ...prev };
      delete updatedErrors[fileType];
      return updatedErrors;
    });

    SafeToast.success(
      `${fileType.replace(/([A-Z])/g, " $1")} uploaded successfully`,
    );
  };

  const handleExamClick = (exam) => {
    setActiveExam(exam);

    const related = subExamOptions.filter(
      (sub) => sub.parentCode === exam.code,
    );

    setActiveSubExam((prev) =>
      related.some((s) => s.id === prev?.id) ? prev : related[0] || null,
    );
  };

  // ✅ FETCH EVERY BATCH FOR THIS TEST BATCH NAME, ACROSS ALL PAGES
  const fetchAllBatchesForBatchName = async (testBatchName) => {
    let page = 1;
    let allBatches = [];
    let total = Infinity;

    while (allBatches.length < total) {
      const response = await getWithTokenAPI(
        token,
        `/batch/get-all?Institution_id=${Institutionprofile._id}&examType=${activeExam.value}&testBatchName=${testBatchName}&page=${page}&all=true`
      );

      if (response?.statusCode !== 200) break;

      const pageData = response?.data?.data || [];
      if (!pageData.length) break;

      allBatches = [...allBatches, ...pageData];
      total = response?.data?.total ?? allBatches.length;
      page += 1;
    }

    return allBatches;
  };

  const handleCreateExamBatch = async (forceProceed = false) => {

    const count = parseInt(numberOfTesting, 10);

    if (isNaN(count) || count < 1 || count > 100) {
      const msg = count > 100 ? "Number of Tests cannot exceed 100" : "Please enter a valid Number of Tests (1-100)";
      SafeToast.error(msg);
      setErrors((prev) => ({ ...prev, numberOfTesting: msg }));
      return;
    }
    setErrors((prev) => ({ ...prev, numberOfTesting: "" }));

    if (!activeExam?.value) {
      SafeToast.error("Select Exam");
      return;
    }

    if (!formData.testBatchName) {
      SafeToast.error("Enter Batch Name");
      return;
    }

    setLoading(true);

    try {
      // ✅ LOAD EVERY EXISTING TEST FOR THIS BATCH NAME (NOT JUST THE LOADED PAGE)
      const allExistingBatches = await fetchAllBatchesForBatchName(formData.testBatchName);
      const validExistingTests = allExistingBatches.filter((t) => t.testNo);
      const existingCount = validExistingTests.length;

      console.log("Existing tests count:", existingCount);
      console.log("count tests count:", count);

      // ⚠️ WARNING: Alert if user attempts to increase test count on an existing batch
      if (existingCount > 0 && count > existingCount && !forceProceed) {
        setLoading(false);
        setPendingTestCountData({ existingCount, count });
        setShowIncreaseTestModal(true);
        return;
      }

      // ✅ SYNC SHARED FIELDS (TEST BATCH NAME, TEST FEES, SCHEDULE PDF) ACROSS ALL EXISTING TESTS
      for (const test of validExistingTests) {
        if (parseInt(test.testNo) > count) {
          continue; // Skip updating tests that are about to be deleted
        }

        const batchData = {
          Institution_id: Institutionprofile._id,

          examType: activeExam.value,

          testFees: parseInt(formData.testFees) || 0,

          testBatchName: formData.testBatchName,

          schedulePdf:
            formData?.schedulePdf?.url || "",

          testNo: parseInt(test.testNo),

          totalQuestions: parseInt(test.totalQuestions) || 0,

          numberofTests: count,

          isPublished: test.isPublished || false,
          isDraft: test.isDraft || false,

          questionFiles: {
            questionPdf: test.questionFiles?.questionPdf || "",
            answerPdf: test.questionFiles?.answerPdf || "",
            videoLink: test.questionFiles?.videoLink || "",
            answers: test.questionFiles?.answers || [],
            omrsheet: test.questionFiles?.omrsheet || "",
          },
        };

        await putWithTokenAPI(
          token,
          `/batch/update/${test._id}`,
          batchData
        );
      }

      // ✅ CREATE NEW TESTS ONLY WHEN NUMBER OF TESTS ACTUALLY INCREASED
      if (count > existingCount) {
        for (let i = existingCount + 1; i <= count; i++) {
          const batchData = {
            Institution_id: Institutionprofile._id,

            examType: activeExam.value,

            testFees: parseInt(formData.testFees) || 0,

            testBatchName: formData.testBatchName,

            schedulePdf:
              formData?.schedulePdf?.url || "",

            testNo: i,

            totalQuestions: 0,

            numberofTests: count,

            isPublished: false,
            isDraft: false,

            questionFiles: {
              questionPdf: "",
              answerPdf: "",
              videoLink: "",
              answers: [],
              omrsheet: "",
            },
          };

          await postWithTokenAPI(
            token,
            batch_create,
            batchData
          );
        }

        SafeToast.success("New exam batches created");
      } else if (count < existingCount) {
        // ✅ DELETE EXTRANEOUS TESTS WHEN NUMBER OF TESTS DECREASED
        for (let i = count + 1; i <= existingCount; i++) {
          const testToDelete = validExistingTests.find(
            (t) => parseInt(t.testNo) === i
          );
          if (testToDelete) {
            await deleteWithTokenAPI(
              token,
              `/batch/delete/${testToDelete._id}`
            );
          }
        }
        SafeToast.success("Batch details updated and extra tests removed");
      } else {
        SafeToast.success("Batch details updated for all tests");
      }

      // KEEP CURRENT TEST
      const currentIndex = currentTestIndex;

      // OPTIONAL REFRESH
      await fetchBatchList();

      // RESTORE CURRENT TEST
      setCurrentTestIndex(currentIndex);

      // ✅ REFRESH DROPDOWN OPTIONS LIST
      await fetchBatchNames();

      setIsExistingBatch(true);

    } catch (error) {

      console.log(error);

      SafeToast.error("Failed to create batch");

    } finally {

      setLoading(false);

    }
  };

  const handleDeleteBatch = async () => {
    if (!formData.testBatchName) {
      SafeToast.error("No test batch selected to delete");
      return;
    }

    try {
      setIsDeletingBatch(true);

      // Fetch all batch documents associated with this batch name to ensure all tests are found
      const allExistingBatches = await fetchAllBatchesForBatchName(
        formData.testBatchName
      );

      const batchIdsToDelete = new Set();
      if (Array.isArray(allExistingBatches) && allExistingBatches.length > 0) {
        allExistingBatches.forEach((b) => {
          if (b?._id) batchIdsToDelete.add(b._id);
        });
      }

      // Also add any IDs from currently loaded tests
      if (Array.isArray(tests) && tests.length > 0) {
        tests.forEach((t) => {
          if (t?._id) batchIdsToDelete.add(t._id);
        });
      }

      if (batchIdsToDelete.size === 0) {
        SafeToast.error("No tests found to delete for this batch");
        setIsDeletingBatch(false);
        setShowDeleteBatchModal(false);
        return;
      }

      // Delete all tests in the batch
      const deletePromises = Array.from(batchIdsToDelete).map((id) =>
        deleteWithTokenAPI(token, `/batch/delete/${id}`)
      );

      await Promise.all(deletePromises);

      SafeToast.success("Test batch and associated tests deleted permanently");

      // Reset form and state to remove from active view
      setIsExistingBatch(false);
      setFormData({
        testBatchName: "",
        headlineTagline: "",
        bannerTagline: "",
        testFees: "",
        syllabus: "",
        subTopic: "",
        schedulePdf: null,
      });

      setAnswers({});
      localStorage.removeItem("omrAnswers");
      localStorage.removeItem("allOmrAnswers");
      localStorage.removeItem("testBatches");

      setTests([
        {
          testNo: "",
          totalQuestions: "",
          questionPdf: null,
          omrsheet: null,
          videoLink: "",
          isPublished: false,
          isDraft: false,
        },
      ]);
      setNumberOfTesting(1);
      setCurrentTestIndex(0);
      prevTestNoRef.current = "";

      // Refresh batch list dropdown
      await fetchBatchNames();
      setShowDeleteBatchModal(false);
    } catch (error) {
      console.error("Error deleting test batch:", error);
      SafeToast.error("Failed to delete test batch. Please try again.");
    } finally {
      setIsDeletingBatch(false);
    }
  };


  const fetchBatchList = async () => {

    try {

      const response = await getWithTokenAPI(
        token,
        `/batch/get-all?Institution_id=${Institutionprofile._id}&examType=${activeExam.value}&testBatchName=${formData.testBatchName}&all=true`
      );

      console.log(response, "REFETCHED BATCHES");

      if (response?.statusCode === 200) {

        const batches = response?.data?.data || [];

        const latestPublishedBatch = batches
          .filter((item) => item.isPublished && item.totalQuestions)
          .sort(
            (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
          )[0];

        const calculatedLastUpdatedQuestions = latestPublishedBatch?.totalQuestions || 0;
        setLastUpdatedQuestions(calculatedLastUpdatedQuestions);

        // ✅ REMOVE DUPLICATES USING testNo
        const uniqueTests = [
          ...new Map(
            batches.map((item) => [
              item.testNo,
              item
            ])
          ).values()
        ];

        // ✅ SORT ASCENDING
        uniqueTests.sort((a, b) => a.testNo - b.testNo);

        const mappedTests = uniqueTests.map((item) => {
          const hasDraftContent = Boolean(
            (item?.totalQuestions && parseInt(item.totalQuestions) > 0) ||
            item?.questionFiles?.questionPdf ||
            (item?.questionFiles?.answers && item.questionFiles.answers.length > 0) ||
            item?.questionFiles?.omrsheet ||
            item?.questionFiles?.videoLink
          );
          const isPublished = Boolean(item?.isPublished);
          const isDraft = !isPublished && (item?.isDraft === true || (item?.isDraft === undefined && hasDraftContent));

          return {
            _id: item?._id || "",

            testNo: item?.testNo || "",

            totalQuestions: (item?.totalQuestions && parseInt(item.totalQuestions) > 0)
              ? item.totalQuestions
              : (calculatedLastUpdatedQuestions || ""),

            questionPdf: item?.questionFiles?.questionPdf
              ? {
                name: "Question PDF",
                url: item.questionFiles.questionPdf,
              }
              : null,

            omrsheet: item?.questionFiles?.omrsheet
              ? {
                name: "OMR Sheet",
                url: item.questionFiles.omrsheet,
              }
              : null,

            videoLink: item?.questionFiles?.videoLink || "",

            answers: item?.questionFiles?.answers || [],

            isPublished,
            isDraft,
          };
        });

        setTests(mappedTests);

        setNumberOfTesting(mappedTests.length);

      }

    } catch (error) {

      console.log(error);

    }
  };


  const handleSaveDraft = async () => {
    if (loading || draftLoading) return;

    if (!activeExam?.value) {
      SafeToast.error("Select Exam");
      return;
    }

    // ✅ CURRENT TEST
    const currentTest = tests[currentTestIndex];

    if (!currentTest) {
      SafeToast.error("No Test Found");
      return;
    }

    if (!formData.testBatchName) {
      SafeToast.error("Test Batch Name is required");
      return;
    }

    setDraftLoading(true);

    try {
      // Format answers from state or fallback to test's existing answers
      let answersArray = [];
      if (answers && Object.keys(answers).length > 0) {
        answersArray = Object.entries(answers)
          .filter(([_, value]) => value)
          .map(([questionNumber, correctAnswer]) => ({
            questionNumber: parseInt(questionNumber),
            correctAnswer,
          }));
      } else if (Array.isArray(currentTest.answers) && currentTest.answers.length > 0) {
        answersArray = currentTest.answers;
      }

      let questionPdfUrl = "";

      // ✅ PDF UPLOAD IF NEW FILE SELECTED
      if (currentTest.questionPdf instanceof File) {
        const uploaded = await uploadFile(
          "questionPdf",
          currentTest.questionPdf
        );

        if (uploaded) {
          questionPdfUrl = uploaded;
        } else {
          SafeToast.error("Failed to upload Question PDF");
          setDraftLoading(false);
          return;
        }
      } else {
        questionPdfUrl = currentTest.questionPdf?.url || "";
      }

      // ✅ OMR SHEET UPLOAD IF NEW FILE SELECTED
      let omrsheetUrl = "";
      if (currentTest.omrsheet instanceof File) {
        const uploaded = await uploadFile("omrsheet", currentTest.omrsheet);
        if (uploaded) {
          omrsheetUrl = uploaded;
        }
      } else {
        omrsheetUrl = currentTest.omrsheet?.url || "";
      }

      const parsedTotalQ = parseInt(currentTest.totalQuestions);
      const totalQ = !isNaN(parsedTotalQ) && parsedTotalQ > 0 ? parsedTotalQ : 0;

      // ✅ DRAFT BATCH DATA (isPublished: false, isDraft: true)
      const batchData = {
        Institution_id: Institutionprofile._id,
        examType: activeExam.value,
        testFees: parseInt(formData.testFees) || 0,
        testBatchName: formData.testBatchName || "",
        schedulePdf: formData?.schedulePdf?.url || "",
        testNo: parseInt(currentTest.testNo),
        totalQuestions: totalQ,
        numberofTests: numberOfTesting,
        isPublished: false,
        isDraft: true,
        questionFiles: {
          questionPdf: questionPdfUrl,
          answerPdf: formData?.answerPdf?.url || "",
          videoLink: currentTest.videoLink || "",
          answers: answersArray,
          omrsheet: omrsheetUrl,
        },
      };

      // UPDATE OR CREATE TEST IN DB
      let response;
      if (currentTest._id) {
        response = await putWithTokenAPI(
          token,
          `/batch/update/${currentTest._id}`,
          batchData
        );
      } else {
        response = await postWithTokenAPI(
          token,
          batch_create,
          batchData
        );
      }

      if (
        response?.statusCode === 200 ||
        response?.statusCode === 201
      ) {
        // Clear any previous validation errors
        setErrors({});

        // UPDATE ONLY CURRENT TEST
        setTests((prev) =>
          prev.map((t, index) =>
            index === currentTestIndex
              ? {
                ...t,
                isPublished: false,
                isDraft: true,
                totalQuestions: totalQ > 0 ? totalQ : t.totalQuestions,
                questionPdf: questionPdfUrl
                  ? {
                    name: currentTest.questionPdf?.name || "Question PDF",
                    url: questionPdfUrl,
                  }
                  : null,
                videoLink: currentTest.videoLink || "",
                answers: answersArray,
              }
              : t
          )
        );

        SafeToast.success(
          `Test ${currentTest.testNo} Saved as Draft`
        );

        // Keep current index & refresh data from server
        const currentIndex = currentTestIndex;
        await fetchBatchList();
        setCurrentTestIndex(currentIndex);
      } else {
        SafeToast.error(response?.message || "Failed to save draft");
      }
    } catch (error) {
      console.error(error);
      SafeToast.error("Failed to save draft");
    } finally {
      setDraftLoading(false);
    }
  };

  const handlePublish = async () => {

    if (loading || draftLoading) return;

    if (!activeExam?.value) {
      SafeToast.error("Select Exam");
      return;
    }

    // ✅ CURRENT TEST
    const currentTest = tests[currentTestIndex];

    if (!currentTest) {
      SafeToast.error("No Test Found");
      return;
    }

    // ✅ VALIDATE REQUIRED FIELDS
    const validationErrors = {};

    const totalQNum = parseInt(currentTest.totalQuestions);
    if (!currentTest.totalQuestions || totalQNum <= 0) {
      validationErrors.totalQuestions = "Total Questions is required";
    } else if (totalQNum !== 100 && totalQNum !== 200) {
      validationErrors.totalQuestions = "Please enter either 100 or 200 questions only.";
    }

    // Question PDF is optional during publishing

    if (Object.keys(validationErrors).length > 0) {
      setErrors((prev) => ({ ...prev, ...validationErrors }));
      SafeToast.error("Please fill all required fields");
      return;
    }

    setLoading(true);

    try {

      const answersArray = Object.entries(answers)
        .filter(([_, value]) => value)
        .map(([questionNumber, correctAnswer]) => ({
          questionNumber: parseInt(questionNumber),
          correctAnswer,
        }));

      let questionPdfUrl = "";

      // ✅ PDF UPLOAD
      if (currentTest.questionPdf instanceof File) {

        const uploaded = await uploadFile(
          "questionPdf",
          currentTest.questionPdf
        );

        if (uploaded) {
          questionPdfUrl = uploaded;
        } else {
          SafeToast.error("Failed to upload Question PDF");
          setLoading(false);
          return;
        }

      } else {

        questionPdfUrl =
          currentTest.questionPdf?.url || "";

      }

      // ✅ API DATA
      const batchData = {

        Institution_id: Institutionprofile._id,

        examType: activeExam.value,



        testFees: parseInt(formData.testFees) || 0,

        testBatchName: formData.testBatchName || "",



        schedulePdf:
          formData?.schedulePdf?.url || "",

        testNo: parseInt(currentTest.testNo),

        totalQuestions: parseInt(
          currentTest.totalQuestions || lastUpdatedQuestions || 0
        ) || 0,

        numberofTests: numberOfTesting,

        isPublished: true,
        isDraft: false,

        questionFiles: {

          questionPdf: questionPdfUrl,

          answerPdf:
            formData?.answerPdf?.url || "",

          videoLink:
            currentTest.videoLink || "",

          answers: answersArray,

          omrsheet:
            currentTest.omrsheet?.url || "",
        },
      };

      // ✅ IMPORTANT
      // UPDATE EXISTING TEST
      const response = await putWithTokenAPI(
        token,
        `/batch/update/${currentTest._id}`,
        batchData
      );

      if (
        response?.statusCode === 200 ||
        response?.statusCode === 201
      ) {

        // ✅ UPDATE ONLY CURRENT TEST
        setTests((prev) =>
          prev.map((t, index) =>
            index === currentTestIndex
              ? {
                ...t,
                isPublished: true,
                isDraft: false,
              }
              : t
          )
        );

        SafeToast.success(
          `Test ${currentTest.testNo} ${tests[currentTestIndex]?.isPublished ? "Updated" : "Published"} Successfully`
        );

        // ✅ KEEP CURRENT INDEX
        const currentIndex = currentTestIndex;

        // ✅ REFRESH DATA
        await fetchBatchList();

        // ✅ RESTORE INDEX
        setCurrentTestIndex(currentIndex);
      }

    } catch (error) {

      console.log(error);

      SafeToast.error("Publish Failed");

    } finally {

      setLoading(false);

    }
  };


  const ExamscrollLeft = () => {
    if (ExamtabsRef.current) {
      ExamtabsRef.current.scrollBy({ left: -200, behavior: "smooth" });
    }
  };

  const ExamscrollRight = () => {
    if (ExamtabsRef.current) {
      ExamtabsRef.current.scrollBy({ left: 200, behavior: "smooth" });
    }
  };



  const handleNavigateToOMR = () => {
    localStorage.setItem("uploadFormData", JSON.stringify(formData));

    let finalAnswers = answers;
    const currentTest = tests[currentTestIndex];

    console.log(currentTest, 'currentTest')
    if (
      (!finalAnswers || Object.keys(finalAnswers).length === 0) &&
      currentTest?.answers?.length > 0
    ) {
      const formattedAnswers = {};
      currentTest.answers.forEach((ans) => {
        if (ans.questionNumber && ans.correctAnswer) {
          formattedAnswers[ans.questionNumber] = ans.correctAnswer;
        }
      });
      finalAnswers = formattedAnswers;
      setAnswers(formattedAnswers);
    }

    localStorage.setItem("omrAnswers", JSON.stringify(finalAnswers));

    console.log(finalAnswers, "ANSWERS");
    // Use the current test card's totalQuestions so OMR page generates correct slots
    const currentTestQuestions = tests[currentTestIndex]?.totalQuestions || totalQuestions || 0;
    localStorage.setItem("totalQuestions", currentTestQuestions);
    // Persist test batch state so it survives navigation
    localStorage.setItem("testBatches", JSON.stringify(tests));
    localStorage.setItem("numberOfTesting", numberOfTesting);
    localStorage.setItem("currentTestIndex", currentTestIndex);


    // tests[currentTestIndex]?.videoLink
    navigate("/omr");
  };

  const isExamChecked = (exam) => {
    if (isExam) {
      return examOptions.some((ex) => ex.code === exam.value);
    } else {
      return subExamOptions.some(
        (sub) => (sub.id || sub.value) === (exam.id || exam.value),
      );
    }
  };






  const filteredSubExams = activeExam
    ? allSubexamOptions.filter((sub) => sub.value === activeExam.code)
    : [];

  const deleteUserExam = async ({ exams = [], subexams = [] }) => {
    if (!token || !userId) {
      console.warn("Missing token or userId");
      return;
    }

    if (!exams.length && !subexams.length) {
      console.warn("Nothing to delete");
      return;
    }

    try {
      const res = await deleteWithTokenAPIpayload(
        token,
        `/user/${userId}/exams-remove`,
        {
          exams,
          subexams,
        },
      );

      if (res?.statusCode === 200) {
        SafeToast.success("Removed successfully");
      } else {
        SafeToast.error(res?.message || "Remove failed");
      }
    } catch (error) {
      console.error("Delete exam error:", error);
      SafeToast.error("Delete failed");
    }
  };
  const getExamId = (exam) => exam?.id || exam?.value || null;


  const handleAddExamClick = async (exam) => {
    if (!exam) return;

    const examId = getExamId(exam);
    if (!examId) {
      console.warn("Invalid exam object", exam);
      return;
    }

    const examset = {
      id: examId,
      label: exam.label,
      value: examId,
    };

    if (isExam) {
      const exists = examOptions.some((ex) => ex.label === exam.label);

      if (exists) {
        // ✅ SAFE DELETE
        await deleteUserExam({
          exams: [examId],
          subexams: [],
        });

        setExamOptions((prev) => prev.filter((ex) => ex.label !== exam.label));
      } else {
        setExamOptions((prev) => [...prev, examset]);
        await handleSaveExam(examset);
      }
    } else {
      const exists = subExamOptions.some(
        (ex) => (ex.id || ex.value) === examId,
      );

      if (exists) {
        // ✅ SAFE DELETE
        await deleteUserExam({
          exams: [],
          subexams: [examId],
        });

        setSubExamOptions((prev) =>
          prev.filter((ex) => (ex.id || ex.value) !== examId),
        );
      } else {
        if (!activeExam?.code) {
          SafeToast.error("Select an exam first");
          return;
        }
        setSubExamOptions((prev) => [
          ...prev,
          {
            ...exam,
            parentCode: activeExam.code,
          },
        ]);
        await handleSaveExam(examset);
      }
    }
  };

  const handleSaveExam = async (exam) => {
    try {
      const payload = {
        [isExam ? "exams" : "subexams"]: [exam.id],
      };
      const res = await putWithTokenAPI(
        token,
        `${user_exams_add}/${userId}/exams-add`,
        payload,
      );

      if (res?.statusCode === 200) {
        SafeToast.success("Profile updated successfully");

        dispatch(
          setProfileData({
            name:
              roleType === "superadmin"
                ? res.data.name
                : res.data.nameofInstitution,
            phone: res.data.phoneNumber,
            role: res.data.roleType,
            price: res.data.adminPrice,
            profileImage: res.data.profile_img,
            logo: res.data.logo,
          }),
        );
        fetchUserExams();
      } else {
        SafeToast.error(res?.message || "Update failed");
      }
    } catch (error) {
      console.error("Update error:", error);
      SafeToast.error("Something went wrong");
    }
  };

  const handleOpenDialog = (name) => {
    console.log(name, "handleOpenDialog");
    setExamName(name);
    setOpenDialog(true);
  };




  const [omrModalOpen, setOmrModalOpen] = useState(false);

  const handleSelectOMR = async (templateName, templateSrc) => {
    setLoading(true);
    try {
      const response = await fetch(templateSrc);
      const blob = await response.blob();
      const file = new File([blob], `${templateName.toLowerCase().replace(/ /g, "_")}.png`, { type: "image/png" });
      const fileUrl = await uploadFile("omrsheet", file);
      if (fileUrl) {
        setTests((prev) => {
          const updated = [...prev];
          if (updated[currentTestIndex]) {
            updated[currentTestIndex].omrsheet = {
              name: `${templateName}.png`,
              url: fileUrl,
              localSrc: templateSrc,
            };
          }
          return updated;
        });

        // Keep it in formData too, just in case other things use it
        setFormData((prev) => ({
          ...prev,
          omrsheet: {
            name: `${templateName}.png`,
            url: fileUrl,
            localSrc: templateSrc,
          },
        }));

        SafeToast.success(`${templateName} template selected and uploaded!`);
      }
    } catch (error) {
      console.error("Error uploading OMR template:", error);
      SafeToast.error("Failed to upload OMR template");
    } finally {
      setLoading(false);
      setOmrModalOpen(false);
    }
  };

  const getLocalOMRTemplate = (name) => {
    if (!name) return null;
    const cleanName = name.toLowerCase();
    if (cleanName.includes("20 ")) return OMR_20;
    if (cleanName.includes("50 ")) return OMR_50;
    if (cleanName.includes("100 ")) return OMR_100;
    if (cleanName.includes("150 ")) return OMR_150;
    if (cleanName.includes("200 ")) return OMR_200;
    return null;
  };

  const handleOMRDownload = async () => {
    const currentOmr = tests[currentTestIndex]?.omrsheet;
    if (currentOmr) {
      const localAsset = getLocalOMRTemplate(currentOmr.name) || currentOmr.localSrc;
      const downloadUrl = localAsset || currentOmr.url;

      if (!downloadUrl) return;

      // Open in a new tab for viewing
      window.open(downloadUrl, "_blank");
    }
  };
  const [omrDialogOpen, setOmrDialogOpen] = useState(false);
  const [omrPage, setOmrPage] = useState(1);

  const handleOpenOMRDialog = () => {
    const currentTest = tests[currentTestIndex];
    if (!currentTest) return;

    setOmrPage(1);

    if (
      currentTest.answers &&
      currentTest.answers.length > 0
    ) {
      const formattedAnswers = {};
      currentTest.answers.forEach((ans) => {
        if (ans.questionNumber && ans.correctAnswer) {
          formattedAnswers[ans.questionNumber] = ans.correctAnswer;
        }
      });
      setAnswers(formattedAnswers);
      localStorage.setItem("omrAnswers", JSON.stringify(formattedAnswers));
    }

    setOmrDialogOpen(true);
  };


  const [numberOfTesting, setNumberOfTesting] = useState(() => {
    const saved = localStorage.getItem("numberOfTesting");
    return saved ? parseInt(saved) : 1;
  });

  const [currentTestIndex, setCurrentTestIndex] = useState(() => {
    const saved = localStorage.getItem("currentTestIndex");
    return saved ? parseInt(saved) : 0;
  });

  const [tests, setTests] = useState(() => {
    try {
      const saved = localStorage.getItem("testBatches");
      if (saved) return JSON.parse(saved);
    } catch (e) { }
    return [
      {
        testNo: "",
        totalQuestions: "",
        questionPdf: null,
        omrsheet: null,
        videoLink: "",
        isPublished: false,
        isDraft: false,
      },
    ];
  });

  // Persist tests to localStorage whenever they change
  useEffect(() => {
    localStorage.setItem("testBatches", JSON.stringify(tests));
  }, [tests]);

  useEffect(() => {
    localStorage.setItem("numberOfTesting", numberOfTesting);
  }, [numberOfTesting]);

  useEffect(() => {
    localStorage.setItem("currentTestIndex", currentTestIndex);
  }, [currentTestIndex]);

  // Effect to sync answers when switching tests or loading test data
  useEffect(() => {
    const currentTest = tests[currentTestIndex];
    if (!currentTest || !currentTest.testNo) return;

    const allAnswers = JSON.parse(localStorage.getItem("allOmrAnswers") || "{}");

    // Case 1: We switched tests!
    if (prevTestNoRef.current && prevTestNoRef.current !== currentTest.testNo) {
      // Now load the new test's answers
      let testAnswers = allAnswers[currentTest.testNo];
      if (!testAnswers || Object.keys(testAnswers).length === 0) {
        if (currentTest.answers && currentTest.answers.length > 0) {
          const formattedAnswers = {};
          currentTest.answers.forEach((ans) => {
            if (ans.questionNumber && ans.correctAnswer) {
              formattedAnswers[ans.questionNumber] = ans.correctAnswer;
            }
          });
          testAnswers = formattedAnswers;
          allAnswers[currentTest.testNo] = testAnswers;
          localStorage.setItem("allOmrAnswers", JSON.stringify(allAnswers));
        } else {
          testAnswers = {};
        }
      }

      setAnswers(testAnswers);
      localStorage.setItem("omrAnswers", JSON.stringify(testAnswers));
      prevTestNoRef.current = currentTest.testNo;
      return;
    }

    // Case 2: First load or data came from server — only set if answers state is empty
    if (!answers || Object.keys(answers).length === 0) {
      let testAnswers = allAnswers[currentTest.testNo];
      if (!testAnswers || Object.keys(testAnswers).length === 0) {
        if (currentTest.answers && currentTest.answers.length > 0) {
          const formattedAnswers = {};
          currentTest.answers.forEach((ans) => {
            if (ans.questionNumber && ans.correctAnswer) {
              formattedAnswers[ans.questionNumber] = ans.correctAnswer;
            }
          });
          testAnswers = formattedAnswers;
          allAnswers[currentTest.testNo] = testAnswers;
          localStorage.setItem("allOmrAnswers", JSON.stringify(allAnswers));
        }
      }
      if (testAnswers && Object.keys(testAnswers).length > 0) {
        setAnswers(testAnswers);
        localStorage.setItem("omrAnswers", JSON.stringify(testAnswers));
      }
    }

    prevTestNoRef.current = currentTest.testNo;
  }, [currentTestIndex, tests]);

  // Separate effect to save answers to localStorage whenever they change
  useEffect(() => {
    const currentTest = tests[currentTestIndex];
    if (!currentTest || !currentTest.testNo) return;
    if (!answers || Object.keys(answers).length === 0) return;

    const allAnswers = JSON.parse(localStorage.getItem("allOmrAnswers") || "{}");
    allAnswers[currentTest.testNo] = answers;
    localStorage.setItem("allOmrAnswers", JSON.stringify(allAnswers));
    localStorage.setItem("omrAnswers", JSON.stringify(answers));
  }, [answers]);

  const handleResetToNewBatch = () => {
    setIsExistingBatch(false);
    setFormData((prev) => ({
      ...prev,
      testBatchName: "",
      testFees: "",
      headlineTagline: "",
      bannerTagline: "",
      schedulePdf: null,
      syllabus: "",
      subTopic: "",
    }));
    setAnswers({});
    localStorage.removeItem("omrAnswers");
    localStorage.removeItem("allOmrAnswers");
    localStorage.removeItem("testBatches");
    setTests([
      {
        testNo: "",
        totalQuestions: "",
        questionPdf: null,
        omrsheet: null,
        videoLink: "",
        isPublished: false,
        isDraft: false,
      },
    ]);
    setNumberOfTesting(1);
    setCurrentTestIndex(0);
    prevTestNoRef.current = "";
  };

  const handleBatchSelect = async (selected, targetTestNo = null, overrideExamType = null) => {
    if (!selected || selected.value === "add_new") {
      handleResetToNewBatch();
      return;
    }

    setIsExistingBatch(true);

    try {
      const examVal = overrideExamType || activeExam?.value || "";
      const response = await getWithTokenAPI(
        token,
        `/batch/get-all?Institution_id=${Institutionprofile._id}${examVal ? `&examType=${examVal}` : ""}&testBatchName=${encodeURIComponent(selected.value)}&all=true`
      );

      if (response?.statusCode === 200) {

        // ✅ FIXED
        const batches = response?.data?.data || [];

        // ✅ SAFETY CHECK
        if (!batches.length) {
          SafeToast.error("No batch found");
          return;
        }

        const latestPublishedBatch = batches
          .filter((item) => item.isPublished && item.totalQuestions)
          .sort(
            (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
          )[0];

        const calculatedLastUpdatedQuestions = latestPublishedBatch?.totalQuestions || 0;
        setLastUpdatedQuestions(calculatedLastUpdatedQuestions);

        // Clear old cached answers and reset answers state when switching batches
        localStorage.removeItem("allOmrAnswers");
        localStorage.removeItem("omrAnswers");
        setAnswers({});
        prevTestNoRef.current = "";

        const first = batches[0];

        setFormData((prev) => ({
          ...prev,
          testBatchName: first?.testBatchName || "",
          headlineTagline: first?.headlineTagline || "",
          bannerTagline: first?.bannerTagline || "",
          testFees: first?.testFees || "",
          syllabus: first?.syllabus || "",
          subTopic: first?.subTopic || "",
          schedulePdf: first?.schedulePdf
            ? {
              name: "Schedule PDF",
              url: first.schedulePdf,
            }
            : null,
        }));


        // ✅ REMOVE DUPLICATES USING testNo
        const uniqueTests = [
          ...new Map(
            batches.map((item) => [
              item.testNo,
              item
            ])
          ).values()
        ];

        // ✅ SORT ASCENDING
        uniqueTests.sort((a, b) => a.testNo - b.testNo);

        // ✅ TESTS WITH FULL MAPPING
        const mappedTests = uniqueTests.map((item) => {
          const hasDraftContent = Boolean(
            (item?.totalQuestions && parseInt(item.totalQuestions) > 0) ||
            item?.questionFiles?.questionPdf ||
            (item?.questionFiles?.answers && item.questionFiles.answers.length > 0) ||
            item?.questionFiles?.omrsheet ||
            item?.questionFiles?.videoLink
          );
          const isPublished = Boolean(item?.isPublished);
          const isDraft = !isPublished && (item?.isDraft === true || (item?.isDraft === undefined && hasDraftContent));

          return {
            _id: item?._id || "",

            testNo: item?.testNo || "",

            totalQuestions: (item?.totalQuestions && parseInt(item.totalQuestions) > 0)
              ? item.totalQuestions
              : (calculatedLastUpdatedQuestions || ""),

            questionPdf: item?.questionFiles?.questionPdf
              ? {
                name: "Question PDF",
                url: item.questionFiles.questionPdf,
              }
              : null,

            omrsheet: item?.questionFiles?.omrsheet
              ? {
                name: "OMR Sheet",
                url: item.questionFiles.omrsheet,
              }
              : null,

            videoLink: item?.questionFiles?.videoLink || "",

            answers: item?.questionFiles?.answers || [],

            isPublished,
            isDraft,
          };
        });

        setTests(mappedTests);

        setNumberOfTesting(mappedTests.length);

        if (targetTestNo !== null && targetTestNo !== undefined) {
          const targetIdx = mappedTests.findIndex(
            (t) => String(t.testNo) === String(targetTestNo)
          );
          setCurrentTestIndex(targetIdx >= 0 ? targetIdx : 0);
        } else {
          setCurrentTestIndex(0);
        }

        SafeToast.success("Batch loaded successfully");
      }

    } catch (error) {
      console.log(error);
      SafeToast.error("Failed to load batch");
    }
  };

  // Handle direct navigation to edit a specific test from Batch Details
  useEffect(() => {
    const editBatch = location.state?.editBatchName;
    const editExam = location.state?.editExamType;
    const editTestNo = location.state?.editTestNo;

    if (!editBatch || editHandledRef.current) return;
    if (!Institutionprofile?._id || !examOptions.length) return;

    let targetExam = activeExam;
    if (editExam) {
      const found = examOptions.find(
        (e) => e.value === editExam || e.id === editExam || e.label === editExam
      );
      if (found) {
        targetExam = found;
        if (activeExam?.value !== found.value) {
          setActiveExam(found);
        }
      }
    }

    if (targetExam?.value) {
      editHandledRef.current = true;
      handleBatchSelect(
        { label: editBatch, value: editBatch },
        editTestNo,
        targetExam.value
      );
    }
  }, [location.state, examOptions, Institutionprofile, activeExam]);
  return (
    <div className="upload-page">
      <div className="exam-box" style={{ padding: "24px", background: "#fff", borderRadius: "12px", boxShadow: "0 4px 6px -1px rgb(0 0 0 / 0.1)" }}>
        {/* Header Section */}
        <div className="exam-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
          <h4 style={{ margin: 0, fontSize: "1.25rem", fontWeight: "600", color: "#1e293b" }}>Exams</h4>
          <div className="nav-arrows" style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <div className="add-btn-wrapper">
              <button className="add-btn" onClick={() => handleOpenDialog("exam")}>
                <span className="plus">+</span>
                <span className="text">Add</span>
              </button>
            </div>
            <button className="nav-btn" onClick={ExamscrollLeft}>
              <ChevronLeft size={18} />
            </button>
            <button className="nav-btn" onClick={ExamscrollRight}>
              <ChevronRight size={18} />
            </button>
          </div>
        </div>

        {/* Tabs Section */}
        <div className="exam-tabs" style={{ marginBottom: "24px", borderBottom: "1px solid #e2e8f0", paddingBottom: "10px" }} ref={ExamtabsRef}>
          {examOptions.length > 0 ? (
            examOptions.map((exam) => (
              <button
                key={exam.id || exam.value}
                className={activeExam?.value === exam.value ? "active" : ""}
                onClick={() => handleExamClick(exam)}
              >
                {exam.label}
              </button>
            ))
          ) : (
            <div className="no-data-upload" style={{ textAlign: "center", padding: "20px" }}>
              <svg xmlns="http://www.w3.org/2000/svg" className="no-data-upload-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor" style={{ width: "40px", opacity: 0.5 }}>
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2-10H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V8a2 2 0 00-2-2z" />
              </svg>
              <p style={{ color: "#64748b", fontSize: "14px" }}>No exams found</p>
            </div>
          )}
        </div>

        {/* Optional: Load Existing Batch Selector */}
        {batchOptions.length > 0 && (
          <div
            style={{
              marginBottom: "20px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "16px",
              background: "#f8fafc",
              padding: "12px 16px",
              borderRadius: "8px",
              border: "1px solid #e2e8f0",
              flexWrap: "wrap",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "10px", flex: 1, minWidth: "260px" }}>
              <span style={{ fontSize: "13px", fontWeight: "600", color: "#475569", whiteSpace: "nowrap" }}>
                Load Existing Batch:
              </span>
              <div style={{ flex: 1, maxWidth: "380px" }}>
                <Select
                  isClearable
                  placeholder="Select batch to view or edit..."
                  options={batchOptions}
                  value={
                    isExistingBatch && formData.testBatchName
                      ? { label: formData.testBatchName, value: formData.testBatchName }
                      : null
                  }
                  onChange={(selected) => {
                    if (selected) {
                      handleBatchSelect(selected);
                    } else {
                      handleResetToNewBatch();
                    }
                  }}
                />
              </div>
            </div>

            {isExistingBatch && (
              <button
                type="button"
                onClick={handleResetToNewBatch}
                style={{
                  padding: "8px 16px",
                  fontSize: "13px",
                  fontWeight: "600",
                  borderRadius: "6px",
                  border: "1px solid #cbd5e1",
                  background: "#fff",
                  color: "#2563eb",
                  cursor: "pointer",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "6px",
                }}
              >
                + Create New Batch
              </button>
            )}
          </div>
        )}

        {/* Form Fields Grid */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "20px", marginBottom: "24px" }}>

          <div>
            <label
              style={{
                display: "block",
                marginBottom: "8px",
                fontWeight: "500",
                color: "#475569",
              }}
            >
              Test Batch Name :
            </label>

            <input
              type="text"
              name="testBatchName"
              value={formData.testBatchName}
              onChange={(e) => {
                handleInputChange(e);
                if (isExistingBatch) setIsExistingBatch(false);
              }}
              placeholder="Enter Test Batch Name"
              style={{
                width: "100%",
                padding: "12px",
                border: "1px solid #cbd5e1",
                borderRadius: "8px",
                fontSize: "14px",
              }}
            />

            {errors.testBatchName && (
              <p
                style={{
                  color: "#ef4444",
                  fontSize: "12px",
                  marginTop: "4px",
                }}
              >
                {errors.testBatchName}
              </p>
            )}
          </div>
          {/* Test Fees */}
          <div>
            <label style={{ display: "block", marginBottom: "8px", fontWeight: "500", color: "#475569" }}>Test Fees :</label>
            <input
              type="number"
              name="testFees"
              value={formData.testFees}
              onChange={handleInputChange}
              style={{ width: "100%", padding: "12px", border: "1px solid #cbd5e1", borderRadius: "8px", fontSize: "14px" }}
              placeholder="Enter Fee"
            />
            {errors.testFees && <p style={{ color: "#ef4444", fontSize: "12px", marginTop: "4px" }}>{errors.testFees}</p>}
          </div>

          {/* Number of Tests */}
          <div>
            <label
              style={{
                display: "flex",
                alignItems: "center",
                gap: "6px",
                marginBottom: "8px",
                fontWeight: "500",
                color: "#475569",
              }}
            >
              Number of Tests :
              {isExistingBatch && (
                <span
                  style={{
                    fontSize: "11px",
                    fontWeight: "600",
                    color: "#b45309",
                    background: "#fef3c7",
                    padding: "2px 8px",
                    borderRadius: "12px",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "4px",
                  }}
                >
                  <Lock size={11} />
                  Locked
                </span>
              )}
            </label>

            <input
              type="number"
              name="numberOfTesting"
              min="1"
              max="100"
              value={numberOfTesting}
              onChange={(e) => {
                const val = e.target.value;
                if (val === "") {
                  setNumberOfTesting("");
                  setErrors((prev) => ({ ...prev, numberOfTesting: "" }));
                  return;
                }
                const num = parseInt(val, 10);
                if (num > 100) {
                  SafeToast.error("Number of Tests cannot exceed 100");
                  setNumberOfTesting(100);
                  setErrors((prev) => ({
                    ...prev,
                    numberOfTesting: "Number of Tests cannot exceed 100",
                  }));
                } else if (num < 1) {
                  setNumberOfTesting(1);
                  setErrors((prev) => ({ ...prev, numberOfTesting: "" }));
                } else {
                  setNumberOfTesting(num);
                  setErrors((prev) => ({ ...prev, numberOfTesting: "" }));
                }
              }}
              disabled={isExistingBatch}
              placeholder="Enter Number of Tests (1-100)"
              style={{
                width: "100%",
                padding: "12px",
                border: errors.numberOfTesting
                  ? "1px solid #ef4444"
                  : "1px solid #cbd5e1",
                borderRadius: "8px",
                fontSize: "14px",
                background: isExistingBatch ? "#f1f5f9" : "#f8fafc",
                cursor: isExistingBatch ? "not-allowed" : "text",
                color: isExistingBatch ? "#64748b" : "#0f172a",
              }}
            />
            {errors.numberOfTesting && (
              <p style={{ color: "#ef4444", fontSize: "12px", marginTop: "4px" }}>
                {errors.numberOfTesting}
              </p>
            )}

            {isExistingBatch ? (
              <p
                style={{
                  fontSize: "12px",
                  color: "#64748b",
                  marginTop: "6px",
                  marginBottom: 0,
                  lineHeight: "1.4",
                }}
              >
                Note: Total number of tests cannot be edited once the batch is created. If changes are needed, please delete the batch and recreate it.
              </p>
            ) : (
              <p
                style={{
                  fontSize: "12px",
                  color: "#64748b",
                  marginTop: "6px",
                  marginBottom: 0,
                  lineHeight: "1.4",
                }}
              >
                Note: Total number of tests cannot be edited once the batch is created.
              </p>
            )}
          </div>

          {/* Schedule PDF */}
          <div className="schedule-box">
            <label style={{ display: "block", marginBottom: "8px", fontWeight: "500", color: "#475569" }}>Schedule PDF :</label>
            <input
              type="file"
              accept=".pdf"
              onChange={(e) => handleFileUpload("schedulePdf", e.target.files[0])}
              style={{ display: "none" }}
              id="schedulePdf"
            />
            <label htmlFor="schedulePdf" className={formData.schedulePdf ? "uploaded-btn-small" : "upload-btn-small"}
              style={{
                cursor: "pointer",
                display: "inline-block",
                padding: "10px 20px",
                borderRadius: "8px",
                border: "1px dashed #cbd5e1",
                textAlign: "center",
                width: formData.schedulePdf ? "40%" : "80%",
              }}>
              {formData.schedulePdf ? "PDF Selected" : "Click to Upload PDF"}
            </label>

            {formData.schedulePdf && (
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: "8px", padding: "8px", background: "#f1f5f9", borderRadius: "6px" }}>
                <a href={formData.schedulePdf.url} target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none", color: "#2563eb", fontSize: "13px", display: "flex", alignItems: "center", gap: "5px" }}>
                  📄 {formData.schedulePdf.name}
                </a>
                <button onClick={() => handleRemovePdf("schedulePdf")} style={{ border: "none", background: "transparent", cursor: "pointer", color: "#ef4444" }}>
                  <IoClose size={18} />
                </button>
              </div>
            )}
            {errors.schedulePdf && <p style={{ color: "#ef4444", fontSize: "12px", marginTop: "4px" }}>{errors.schedulePdf}</p>}
          </div>
        </div>

        {/* Submit Button Section */}
        <div
          style={{
            borderTop: "1px solid #e2e8f0",
            paddingTop: "20px",
            display: "flex",
            justifyContent: isExistingBatch ? "space-between" : "flex-end",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "12px",
          }}
        >
          {isExistingBatch && (
            <button
              type="button"
              className="delete-batch-btn"
              onClick={() => setShowDeleteBatchModal(true)}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "8px",
                padding: "11px 20px",
                borderRadius: "8px",
                border: "1px solid #fecaca",
                background: "#fef2f2",
                color: "#dc2626",
                fontWeight: "600",
                fontSize: "14px",
                cursor: "pointer",
                transition: "all 0.2s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = "#fee2e2";
                e.currentTarget.style.borderColor = "#f87171";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = "#fef2f2";
                e.currentTarget.style.borderColor = "#fecaca";
              }}
            >
              <Trash2 size={16} />
              Delete Test Batch
            </button>
          )}

          <button
            className="publish-btn"
            onClick={handleCreateExamBatch}
            style={{
              minWidth: "180px",
              padding: "12px 24px",
            }}
          >
            {tests.length > 0 && tests[0]?.testNo !== ""
              ? "Update Exam Batch"
              : "Create Exam Batch"}
          </button>
        </div>
      </div>

      {formData.testBatchName && tests.length > 0 && tests[0]?.testNo !== "" && (
        <div className="main-card">
          <div className="card-body">

            {/* Pagination Tabs */}
            {/* <div
              style={{
                display: "flex",
                gap: "10px",
                marginBottom: "25px",
                flexWrap: "wrap",
              }}
            >
              {tests.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentTestIndex(index)}
                  style={{
                    padding: "10px 18px",
                    borderRadius: "8px",

                    border:
                      tests[index]?.isPublished
                        ? "1px solid green"
                        : currentTestIndex === index
                          ? "1px solid #2563eb"
                          : "1px solid #cbd5e1",

                    background:
                      tests[index]?.isPublished
                        ? "green"
                        : currentTestIndex === index
                          ? "#2563eb"
                          : "#fff",

                    color:
                      tests[index]?.isPublished
                        ? "#fff"
                        : currentTestIndex === index
                          ? "#fff"
                          : "#475569",

                    cursor: "pointer",
                    fontWeight: "600",
                  }}
                >
                  Test {index + 1}
                </button>
              ))}
            </div> */}

            <div
              className="test-buttons-grid-container"
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(130px, 1fr))",
                gap: "10px",
                marginBottom: "25px",
                maxHeight: tests.length > 20 ? "260px" : "none",
                overflowY: tests.length > 20 ? "auto" : "visible",
                padding: "4px 2px",
              }}
            >
              {tests.map((testItem, index) => {
                const isPublished = testItem?.isPublished;
                const isDraft = testItem?.isDraft;
                const isActive = currentTestIndex === index;

                return (
                  <button
                    key={index}
                    type="button"
                    onClick={() => setCurrentTestIndex(index)}
                    style={{
                      width: "100%",
                      minHeight: "42px",
                      padding: "8px 12px",
                      borderRadius: "10px",
                      border: isPublished
                        ? "2px solid #16a34a"
                        : isActive
                          ? "2px solid #2563eb"
                          : "1px solid #cbd5e1",

                      background: isPublished
                        ? "#16a34a"
                        : isActive
                          ? "#eff6ff"
                          : "#ffffff",

                      color: isPublished
                        ? "#ffffff"
                        : isActive
                          ? "#1d4ed8"
                          : "#334155",

                      cursor: "pointer",
                      fontWeight: "600",
                      fontSize: "13px",

                      // Active highlight
                      transform: isActive ? "translateY(-1px)" : "none",
                      boxShadow: isActive
                        ? "0 0 0 3px rgba(37, 99, 235, 0.18)"
                        : "none",

                      transition: "all 0.15s ease",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "6px",
                      boxSizing: "border-box",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {isPublished ? "✓ " : ""}
                    Test {index + 1}
                    {isDraft && !isPublished && (
                      <span
                        style={{
                          fontSize: "10px",
                          padding: "1px 6px",
                          borderRadius: "6px",
                          background: isActive ? "#dbeafe" : "#fef3c7",
                          color: isActive ? "#1e40af" : "#b45309",
                          fontWeight: "600",
                        }}
                      >
                        Draft
                      </span>
                    )}
                  </button>
                );
              })}
            </div>

            {/* Questions Content */}
            <div className="questions-content">

              {/* Active Test Header & Status Badge */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "20px",
                  paddingBottom: "14px",
                  borderBottom: "1px solid #f1f5f9",
                }}
              >
                <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                  <h3
                    style={{
                      margin: 0,
                      fontSize: "18px",
                      fontWeight: "600",
                      color: "#0f172a",
                    }}
                  >
                    Test {tests[currentTestIndex]?.testNo || currentTestIndex + 1}
                  </h3>
                  {tests[currentTestIndex]?.isPublished ? (
                    <span
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "6px",
                        padding: "4px 10px",
                        borderRadius: "12px",
                        fontSize: "12px",
                        fontWeight: "600",
                        background: "#dcfce7",
                        color: "#15803d",
                        border: "1px solid #86efac",
                      }}
                    >
                      <span
                        style={{
                          width: "6px",
                          height: "6px",
                          borderRadius: "50%",
                          background: "#16a34a",
                        }}
                      />
                      Published
                    </span>
                  ) : tests[currentTestIndex]?.isDraft ? (
                    <span
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "6px",
                        padding: "4px 10px",
                        borderRadius: "12px",
                        fontSize: "12px",
                        fontWeight: "600",
                        background: "#fef3c7",
                        color: "#b45309",
                        border: "1px solid #fde68a",
                      }}
                    >
                      <span
                        style={{
                          width: "6px",
                          height: "6px",
                          borderRadius: "50%",
                          background: "#d97706",
                        }}
                      />
                      Draft
                    </span>
                  ) : null}
                </div>
              </div>

              {/* Top Grid */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr 1.2fr",
                  gap: "24px",
                  alignItems: "end",
                }}
              >

                {/* Test No */}
                {/* <div>
                  <label
                    style={{
                      display: "block",
                      marginBottom: "8px",
                      fontWeight: "500",
                    }}
                  >
                    Test No :
                  </label>

                  <div className="confirm-box">
                    <input
                      type="text"
                      value={tests[currentTestIndex]?.testNo}
                      style={{
                        width: "100%",
                        padding: "10px",
                        border: "1px solid #cbd5e1",
                        borderRadius: "8px",
                      }}
                      disabled={true}
                      onChange={(e) => {
                        const updated = [...tests];
                        updated[currentTestIndex].testNo =
                          e.target.value;
                        setTests(updated);
                      }}
                    />
                  </div>
                </div> */}

                {/* Total Questions */}
                <div>
                  <label
                    style={{
                      display: "block",
                      marginBottom: "8px",
                      fontWeight: "500",
                    }}
                  >
                    Total Questions :
                  </label>

                  <div className="confirm-box">
                    <select
                      value={tests[currentTestIndex]?.totalQuestions || ""}
                      style={{
                        width: "100%",
                        padding: "10px 12px",
                        border: errors.totalQuestions
                          ? "1px solid #ef4444"
                          : "1px solid #cbd5e1",
                        borderRadius: "8px",
                        backgroundColor: "#ffffff",
                        fontSize: "14px",
                        color: tests[currentTestIndex]?.totalQuestions ? "#1e293b" : "#64748b",
                        cursor: "pointer",
                        outline: "none",
                      }}
                      onChange={(e) => {
                        const value = e.target.value;
                        const numValue = parseInt(value);

                        if (value !== "" && numValue !== 100 && numValue !== 200) {
                          setErrors((prev) => ({
                            ...prev,
                            totalQuestions: "Please enter either 100 or 200 questions only.",
                          }));
                        } else {
                          setErrors((prev) => ({
                            ...prev,
                            totalQuestions: "",
                          }));
                        }

                        const updated = [...tests];
                        updated[currentTestIndex].totalQuestions = value;
                        setTests(updated);
                      }}
                    >
                      <option value="">
                        {lastUpdatedQuestions && (lastUpdatedQuestions === 100 || lastUpdatedQuestions === 200)
                          ? `Select total questions (Default: ${lastUpdatedQuestions})`
                          : "Select total questions"}
                      </option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      {tests[currentTestIndex]?.totalQuestions &&
                        String(tests[currentTestIndex]?.totalQuestions) !== "100" &&
                        String(tests[currentTestIndex]?.totalQuestions) !== "200" && (
                          <option value={tests[currentTestIndex]?.totalQuestions}>
                            {tests[currentTestIndex]?.totalQuestions} (Invalid)
                          </option>
                        )}
                    </select>
                  </div>
                  <p
                    style={{
                      fontSize: "12px",
                      color: "#64748b",
                      marginTop: "6px",
                      marginBottom: "4px",
                    }}
                  >
                    Note: Number of questions can only be 100 or 200.
                  </p>
                  {errors.totalQuestions && (
                    <p
                      style={{
                        color: "#ef4444",
                        fontSize: "12px",
                        marginTop: "4px",
                      }}
                    >
                      {errors.totalQuestions}
                    </p>
                  )}
                  </div>

                {/* Question PDF */}
                <div>
                  <span
                    style={{
                      display: "block",
                      marginBottom: "8px",
                      fontWeight: "500",
                      fontSize: "13px",
                    }}
                  >
                    Question PDF (Optional) :
                  </span>

                  <div
                    className="upload-card"
                    style={{
                      width: "100%",
                      height: "46px",
                      marginTop: "0",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "0 16px",
                      border: tests[currentTestIndex]?.questionPdf
                        ? "1px solid #22c55e"
                        : errors.questionPdf
                          ? "1px solid #ef4444"
                          : "1px solid #cbd5e1",
                      borderRadius: "8px",
                      background: tests[currentTestIndex]?.questionPdf
                        ? "#f0fdf4"
                        : "#fff",
                      transition: "0.3s",
                    }}
                  >
                    <span
                      style={{
                        fontSize: "14px",
                        color: tests[currentTestIndex]?.questionPdf
                          ? "#16a34a"
                          : "#64748b",
                        fontWeight: "500",
                      }}
                    >
                      {tests[currentTestIndex]?.questionPdf
                        ? "PDF uploaded "
                        : "PDF document"}
                    </span>

                    {tests[currentTestIndex]?.questionPdf ? (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        {/* VIEW BUTTON */}
                        <div
                          onClick={() => {
                            const file = tests[currentTestIndex]?.questionPdf;
                            if (file) {
                              if (file.url) {
                                window.open(file.url, "_blank");
                              } else {
                                const blobUrl = URL.createObjectURL(file);
                                window.open(blobUrl, "_blank");
                              }
                            }
                          }}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                            background: "#22c55e",
                            color: "#fff",
                            padding: "7px 14px",
                            borderRadius: "6px",
                            cursor: "pointer",
                            fontSize: "13px",
                            fontWeight: "600",
                          }}
                        >
                          <Upload size={14} />
                          Uploaded
                        </div>

                        {/* REMOVE BUTTON */}
                        <button
                          onClick={() => {
                            const updated = [...tests];
                            updated[currentTestIndex].questionPdf = null;
                            setTests(updated);
                            setErrors((prev) => ({
                              ...prev,
                              questionPdf: "",
                            }));
                          }}
                          style={{
                            border: "none",
                            background: "#fee2e2",
                            width: "30px",
                            height: "30px",
                            borderRadius: "50%",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#dc2626",
                          }}
                        >
                          <IoClose />
                        </button>
                      </div>
                    ) : (
                      <>
                        <input
                          type="file"
                          accept=".pdf"
                          style={{ display: "none" }}
                          id={`questionPdf-${currentTestIndex}`}
                          onChange={(e) => {
                            if (e.target.files && e.target.files[0]) {
                              const updated = [...tests];
                              updated[currentTestIndex].questionPdf =
                                e.target.files[0];
                              setTests(updated);
                              setErrors((prev) => ({
                                ...prev,
                                questionPdf: "",
                              }));
                            }
                          }}
                        />
                        <label
                          htmlFor={`questionPdf-${currentTestIndex}`}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                            background: "#2563eb",
                            color: "#fff",
                            padding: "7px 14px",
                            borderRadius: "6px",
                            cursor: "pointer",
                            fontSize: "13px",
                            fontWeight: "600",
                            margin: "0",
                          }}
                        >
                          <Upload size={14} />
                          Upload
                        </label>
                      </>
                    )}
                  </div>
                  {errors.questionPdf && (
                    <p
                      style={{
                        color: "#ef4444",
                        fontSize: "12px",
                        marginTop: "4px",
                      }}
                    >
                      {errors.questionPdf}
                    </p>
                  )}
                </div>


                <div>
                  <label
                    style={{
                      display: "block",
                      marginBottom: "8px",
                      fontWeight: "500",
                    }}
                  >
                    Video Link :
                  </label>

                  <input
                    type="text"
                    value={
                      tests[currentTestIndex]?.videoLink
                    }
                    onChange={(e) => {
                      const updated = [...tests];
                      updated[currentTestIndex].videoLink =
                        e.target.value;
                      setTests(updated);
                    }}
                    className="video-url-input"
                    style={{
                      width: "100%",
                      padding: "10px",
                      border: "1px solid #cbd5e1",
                      borderRadius: "8px",
                    }}
                    placeholder="Enter video link"
                  />
                </div>

                {tests[currentTestIndex]?.totalQuestions > 0 && (
                  <div >
                    <span
                      style={{
                        display: "block",
                        marginBottom: "8px",
                        fontWeight: "500",
                        fontSize: "13px",
                      }}
                    >
                      Answer Upload :
                    </span>

                    <div
                      className="answer-card-container"
                      onClick={handleOpenOMRDialog}
                      style={{
                        cursor: "pointer",
                        maxWidth: "320px",
                      }}
                    >
                      <div
                        className="answer-card"
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          background: "#f8fafc",
                          border: "1px solid #e2e8f0",
                          borderRadius: "8px",
                        }}
                      >
                        <button
                          style={{
                            border: "none",
                            background: "none",
                            color: "#1e293b",
                            fontWeight: "600",
                            fontSize: "14px",
                            cursor: "pointer",
                          }}
                        >
                          Answers
                        </button>

                        <div
                          className="eye-icon"
                          style={{ color: "#64748b" }}
                        >
                          <Eye size={18} />
                        </div>
                      </div>
                    </div>
                  </div>
                )}

              </div>

              {/* Second Grid */}
              <div className="questions-content">
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: "24px",
                    alignItems: "start",
                    marginTop: "15px",
                  }}
                >


                  {/* <div>
  <span
    style={{
      display: "block",
      marginBottom: "8px",
      fontWeight: "500",
      fontSize:"13px",
    }}
  >
    OMR Sheet Template
  </span>

  <div
    className="upload-card"
    style={{
      width: "100%",
      height: "46px",
      marginTop: "0",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "0 16px",
      border: tests[currentTestIndex]?.omrsheet
        ? "1px solid #22c55e"
        : "1px solid #cbd5e1",
      borderRadius: "8px",
      background: tests[currentTestIndex]?.omrsheet
        ? "#f0fdf4"
        : "#fff",
      transition: "0.3s",
    }}
  >
    <span
      style={{
        fontSize: "14px",
        color: tests[currentTestIndex]?.omrsheet
          ? "#16a34a"
          : "#64748b",
        fontWeight: "500",
      }}
    >
      {tests[currentTestIndex]?.omrsheet
        ? "OMR Uploaded Successfully"
        : "OMR Sheet Document"}
    </span>

    {tests[currentTestIndex]?.omrsheet ? (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <div
          onClick={handleOMRDownload}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "5px",
            background: "#22c55e",
            color: "#fff",
            padding: "7px 14px",
            borderRadius: "6px",
            cursor: "pointer",
            fontSize: "13px",
            fontWeight: "600",
          }}
        >
          <Download size={14} />
          Uploaded
        </div>
        <button
          onClick={() => {
            const updated = [...tests];
            updated[currentTestIndex].omrsheet = null;
            setTests(updated);
          }}
          style={{
            border: "none",
            background: "#fee2e2",
            width: "30px",
            height: "30px",
            borderRadius: "50%",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#dc2626",
          }}
        >
          <IoClose />
        </button>
      </div>
    ) : (
      <div
        onClick={() => setOmrModalOpen(true)}
        style={{
          display: "flex",
          alignItems: "center",
          gap: "5px",
          background: "#2563eb",
          color: "#fff",
          padding: "7px 14px",
          borderRadius: "6px",
          cursor: "pointer",
          fontSize: "13px",
          fontWeight: "600",
        }}
      >
        <Upload size={14} />
        Upload
      </div>
    )}
  </div>
</div> */}

                  {/* Video Link */}

                </div>


                {/* Bottom Buttons */}
                <div
                  className="publish-row"
                  style={{
                    marginTop: "40px",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >

                  {/* PREVIOUS */}
                  <button
                    className="next-btn-upload"
                    style={{
                      background: "#cbd5e1",
                      color: "#475569",
                    }}
                    disabled={currentTestIndex === 0}
                    onClick={() =>
                      setCurrentTestIndex((prev) => prev - 1)
                    }
                  >
                    <ChevronLeft size={18} />
                    Previous
                  </button>

                  <div
                    style={{
                      display: "flex",
                      gap: "12px",
                    }}
                  >

                    {/* NEXT */}
                    {currentTestIndex !== tests.length - 1 && (
                      <button
                        className="next-btn-upload"
                        onClick={() =>
                          setCurrentTestIndex((prev) => prev + 1)
                        }
                      >
                        Next
                        <ChevronRight size={18} />
                      </button>
                    )}

                    {/* SAVE AS DRAFT */}
                    <button
                      className="draft-btn"
                      disabled={loading || draftLoading}
                      onClick={handleSaveDraft}
                    >
                      <Save size={16} />
                      {draftLoading ? "Saving Draft..." : "Save as Draft"}
                    </button>

                    {/* PUBLISH */}
                    <button
                      className="publish-btn"
                      disabled={loading || draftLoading}
                      onClick={handlePublish}
                    >
                      {tests[currentTestIndex]?.isPublished
                        ? loading
                          ? "Updating..."
                          : "Update"
                        : loading
                          ? "Publishing..."
                          : "Publish"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {openDialog && (
        <div className="modal-overlay">
          <div className="crop-modal">
            <div className="modal-header">
              <h3> {isExam ? "Add New Exam" : "Add Sub New Exam"}</h3>
              <button
                className="close-modal"
                onClick={() => {
                  setShowAddInput(false);
                  setOpenDialog(false);
                }}
              >
                <FiX />
              </button>
            </div>
            <div className="modal-body-exam">
              {showAddInput && (
                <div className="input-box single">
                  <input
                    type="text"
                    value={newExamValue}
                    onChange={(e) => setNewExamValue(e.target.value)}
                    placeholder="Enter new exam"
                  />

                  <div className="add-btn-wrapper">
                    <button className="add-btn" onClick={() => handleAddExam()}>
                      <span className="plus">+</span>
                      <span className="text">Create</span>
                    </button>
                  </div>
                </div>
              )}
              <div
                className="exam-checkbox-list"
                style={{
                  display: isExam
                    ? allexamOptions.length > 0
                      ? "grid"
                      : "block"
                    : filteredSubExams.length > 0
                      ? "grid"
                      : "block",
                }}
              >
                {isExam ? (
                  allexamOptions.length > 0 ? (
                    allexamOptions.map((exam) => (
                      <label
                        key={exam.id || exam.value}
                        className="exam-checkbox-item"
                      >
                        <input
                          type="checkbox"
                          checked={isExamChecked(exam)}
                          onChange={() => handleAddExamClick(exam)}
                        />
                        <span className="check-label">{exam.label}</span>
                      </label>
                    ))
                  ) : (
                    <div className="no-data-upload">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="no-data-upload-icon"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M9 12h6m-6 4h6m2-10H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V8a2 2 0 00-2-2z"
                        />
                      </svg>
                      <span>No exams found</span>
                    </div>
                  )
                ) : filteredSubExams.length > 0 ? (
                  filteredSubExams.map((exam) => {
                    const checked = isExamChecked(exam);
                    return (
                      <label
                        key={exam.id || exam.value}
                        className={`exam-checkbox-item ${checked ? "active" : ""}`}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleAddExamClick(exam);
                        }}
                      >
                        <span className="check-label">{exam.label}</span>
                        {checked && <span className="close-icon">✕</span>}
                      </label>
                    );
                  })
                ) : (
                  <div className="no-data-upload" style={{ width: "90%" }}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="no-data-upload-icon"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 12h6m-6 4h6m2-10H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V8a2 2 0 00-2-2z"
                      />
                    </svg>
                    <span>No exams found</span>
                  </div>
                )}

                {!showAddInput && (
                  <div
                    className="exam-checkbox-item add-exam"
                    onClick={() => setShowAddInput(true)}
                  >
                    <span className="plus-icon">+</span>
                    <span className="check-label">Create</span>
                  </div>
                )}
              </div>
            </div>
            {/* {isExam && ( */}
            <div className="crop-actions">
              <button
                className="cancel-crop-btn"
                onClick={() => {
                  setShowAddInput(false);
                  setOpenDialog(false);
                }}
              >
                Cancel
              </button>
              <button
                className="apply-crop-btn"
                onClick={() => handleAddExam()}
              >
                Save
              </button>
            </div>
            {/* )} */}
          </div>
        </div>
      )}

      {omrModalOpen && (
        <div className="modal-overlay">
          <div className="crop-modal" style={{ maxWidth: "600px" }}>
            <div className="modal-header">
              <h3>Select OMR Sheet Template</h3>
              <button
                className="close-modal"
                onClick={() => setOmrModalOpen(false)}
              >
                <FiX />
              </button>
            </div>
            <div className="modal-body-exam" style={{ maxHeight: "400px", overflowY: "auto" }}>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "20px", padding: "10px" }}>
                {[
                  { name: "OMR 20 Questions", src: OMR_20, questions: 20 },
                  { name: "OMR 50 Questions", src: OMR_50, questions: 50 },
                  { name: "OMR 100 Questions", src: OMR_100, questions: 100 },
                  { name: "OMR 150 Questions", src: OMR_150, questions: 150 },
                  { name: "OMR 200 Questions", src: OMR_200, questions: 200 }
                ].map((template) => (
                  <div
                    key={template.name}
                    className="omr-template-card"
                    style={{
                      border: "1px solid #ddd",
                      borderRadius: "8px",
                      padding: "10px",
                      textAlign: "center",
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                      background: "#fdfdfd"
                    }}
                    onClick={() => handleSelectOMR(template.name, template.src)}
                  >
                    <div style={{ height: "120px", overflow: "hidden", display: "flex", justifyContent: "center", alignItems: "center", border: "1px solid #eee", borderRadius: "4px", marginBottom: "10px", background: "#fff" }}>
                      <img src={template.src} alt={template.name} style={{ height: "100%", objectFit: "contain" }} />
                    </div>
                    <span style={{ fontWeight: "600", fontSize: "14px" }}>{template.name}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

      )}

      {omrDialogOpen && (
        <div
          className="modal-overlay"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(15, 23, 42, 0.4)",
            backdropFilter: "blur(8px)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 99999,
            padding: "20px",
          }}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: "16px",
              width: "90%",
              maxWidth: "1440px",
              maxHeight: "100vh",
              display: "flex",
              flexDirection: "column",
              boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
              overflow: "hidden",
              border: "1px solid rgba(226, 232, 240, 0.8)",
            }}
          >
            {/* Modal Header */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "20px 24px",
                borderBottom: "1px solid #f1f5f9",
                background: "#f8fafc",
              }}
            >
              <div>
                <h3
                  style={{
                    margin: 0,
                    fontSize: "1.25rem",
                    fontWeight: "700",
                    color: "#0f172a",
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  Configure Answer Key - Test {tests[currentTestIndex]?.testNo}
                  {tests[currentTestIndex]?.isPublished ? (
                    <span
                      style={{
                        background: "#dcfce7",
                        color: "#15803d",
                        fontSize: "11px",
                        padding: "4px 8px",
                        borderRadius: "12px",
                        fontWeight: "600",
                      }}
                    >
                      Published
                    </span>
                  ) : tests[currentTestIndex]?.isDraft ? (
                    <span
                      style={{
                        background: "#fef3c7",
                        color: "#b45309",
                        fontSize: "11px",
                        padding: "4px 8px",
                        borderRadius: "12px",
                        fontWeight: "600",
                      }}
                    >
                      Draft
                    </span>
                  ) : null}
                </h3>
                <p style={{ margin: "4px 0 0 0", fontSize: "13px", color: "#64748b" }}>
                  Total Questions: {tests[currentTestIndex]?.totalQuestions}
                </p>
              </div>
              <button
                onClick={() => setOmrDialogOpen(false)}
                style={{
                  border: "none",
                  background: "transparent",
                  cursor: "pointer",
                  color: "#94a3b8",
                  padding: "6px",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  transition: "background 0.2s, color 0.2s",
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.background = "#f1f5f9";
                  e.currentTarget.style.color = "#475569";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.background = "transparent";
                  e.currentTarget.style.color = "#94a3b8";
                }}
              >
                <X size={20} />
              </button>
            </div>

            {/* Pagination Controls */}
            {(() => {
              const totalQ = parseInt(tests[currentTestIndex]?.totalQuestions) || 0;
              const totalPages = Math.ceil(totalQ / 40);
              if (totalPages <= 1) return null;

              return (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "10px",
                    padding: "16px 24px 8px 24px",
                    borderBottom: "1px solid #f1f5f9",
                    background: "#ffffff",
                    overflowX: "auto",
                    whiteSpace: "nowrap",
                  }}
                >
                  <button
                    onClick={() => setOmrPage(prev => Math.max(prev - 1, 1))}
                    disabled={omrPage === 1}
                    style={{
                      padding: "8px 16px",
                      borderRadius: "8px",
                      border: "1px solid #e2e8f0",
                      background: omrPage === 1 ? "#f8fafc" : "#fff",
                      color: omrPage === 1 ? "#94a3b8" : "#475569",
                      fontWeight: "600",
                      fontSize: "13px",
                      cursor: omrPage === 1 ? "not-allowed" : "pointer",
                      transition: "all 0.2s",
                    }}
                  >
                    Previous
                  </button>

                  {Array.from({ length: totalPages }).map((_, idx) => {
                    const pageNum = idx + 1;
                    const pageStart = (pageNum - 1) * 40 + 1;
                    const pageEnd = Math.min(pageNum * 40, totalQ);
                    const isActive = omrPage === pageNum;

                    return (
                      <button
                        key={pageNum}
                        onClick={() => setOmrPage(pageNum)}
                        style={{
                          padding: "8px 16px",
                          borderRadius: "8px",
                          border: isActive ? "none" : "1px solid #e2e8f0",
                          background: isActive ? "#2563eb" : "#f8fafc",
                          color: isActive ? "#fff" : "#475569",
                          fontWeight: "600",
                          fontSize: "13px",
                          cursor: "pointer",
                          boxShadow: isActive ? "0 4px 6px -1px rgba(37, 99, 235, 0.2)" : "none",
                          transition: "all 0.2s",
                          minWidth: "100px",
                        }}
                      >
                        {pageStart} - {pageEnd}
                      </button>
                    );
                  })}

                  <button
                    onClick={() => setOmrPage(prev => Math.min(prev + 1, totalPages))}
                    disabled={omrPage === totalPages}
                    style={{
                      padding: "8px 16px",
                      borderRadius: "8px",
                      border: "1px solid #e2e8f0",
                      background: omrPage === totalPages ? "#f8fafc" : "#fff",
                      color: omrPage === totalPages ? "#94a3b8" : "#475569",
                      fontWeight: "600",
                      fontSize: "13px",
                      cursor: omrPage === totalPages ? "not-allowed" : "pointer",
                      transition: "all 0.2s",
                    }}
                  >
                    Next
                  </button>
                </div>
              );
            })()}

            {/* Modal Body */}
            <div
              style={{
                flex: 1,
                padding: "24px",
                overflowY: "auto",
                background: "#ffffff",
              }}
            >
              {(() => {
                const totalQ = parseInt(tests[currentTestIndex]?.totalQuestions) || 0;
                const startQ = (omrPage - 1) * 40 + 1;
                const endQ = Math.min(omrPage * 40, totalQ);

                const columns = [];
                for (let c = 0; c < 4; c++) {
                  const colStart = startQ + c * 10;
                  if (colStart <= endQ) {
                    const colQuestions = [];
                    const colEnd = Math.min(colStart + 9, endQ);
                    for (let q = colStart; q <= colEnd; q++) {
                      colQuestions.push(q);
                    }
                    columns.push(colQuestions);
                  }
                }

                const renderQuestionItem = (qNo) => {
                  const selectedOpt = answers[qNo];
                  return (
                    <div
                      key={qNo}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "10px 14px",
                        borderRadius: "10px",
                        background: selectedOpt ? "#f0f7ff" : "#f8fafc",
                        border: selectedOpt
                          ? "1px solid #bfdbfe"
                          : "1px solid #e2e8f0",
                        transition: "all 0.2s ease",
                      }}
                    >
                      <span
                        style={{
                          fontWeight: "700",
                          fontSize: "14px",
                          color: selectedOpt ? "#1d4ed8" : "#475569",
                          minWidth: "28px",
                        }}
                      >
                        {qNo}.
                      </span>
                      <div style={{ display: "flex", gap: "6px" }}>
                        {["A", "B", "C", "D"].map((opt) => {
                          const isFilled = selectedOpt === opt;
                          return (
                            <button
                              key={opt}
                              onClick={() => {
                                setAnswers((prev) => {
                                  const updated = { ...prev, [qNo]: opt };
                                  return updated;
                                });
                              }}
                              style={{
                                width: "26px",
                                height: "26px",
                                borderRadius: "50%",
                                border: isFilled
                                  ? "1px solid #2563eb"
                                  : "1px solid #cbd5e1",
                                background: isFilled ? "#2563eb" : "#fff",
                                color: isFilled ? "#fff" : "#64748b",
                                fontSize: "11px",
                                fontWeight: "700",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                cursor: tests[currentTestIndex]?.isPublished
                                  ? "pointer"
                                  : "pointer",
                                transition: "all 0.15s cubic-bezier(0.4, 0, 0.2, 1)",
                                outline: "none",
                              }}
                              onMouseOver={(e) => {
                                if (!isFilled) {
                                  e.currentTarget.style.borderColor = "#2563eb";
                                  e.currentTarget.style.color = "#2563eb";
                                  e.currentTarget.style.background = "#eff6ff";
                                }
                              }}
                              onMouseOut={(e) => {
                                if (!isFilled) {
                                  e.currentTarget.style.borderColor = "#cbd5e1";
                                  e.currentTarget.style.color = "#64748b";
                                  e.currentTarget.style.background = "#fff";
                                }
                              }}
                            >
                              {opt}
                            </button>
                          );
                        })}
                      </div>
                    </div>
                  );
                };

                return (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      gap: "24px",
                      flexWrap: "wrap",
                      padding: "20px 0",
                    }}
                  >
                    {columns.map((colQs, colIdx) => (
                      <div
                        key={colIdx}
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "12px",
                          width: "100%",
                          maxWidth: "280px",
                        }}
                      >
                        {colQs.map(qNo => renderQuestionItem(qNo))}
                      </div>
                    ))}
                  </div>
                );
              })()}
            </div>

            {/* Modal Footer */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "16px 24px",
                borderTop: "1px solid #f1f5f9",
                background: "#f8fafc",
              }}
            >
              <div>
                <button
                  onClick={() => {
                    setAnswers({});
                    localStorage.setItem("omrAnswers", JSON.stringify({}));
                  }}
                  style={{
                    border: "1px solid #ef4444",
                    background: "transparent",
                    color: "#ef4444",
                    padding: "8px 16px",
                    borderRadius: "8px",
                    fontWeight: "600",
                    fontSize: "13px",
                    cursor: "pointer",
                    transition: "all 0.2s",
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.background = "#fef2f2";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.background = "transparent";
                  }}
                >
                  Clear All
                </button>
              </div>
              <div style={{ display: "flex", gap: "12px" }}>
                <button
                  onClick={() => setOmrDialogOpen(false)}
                  style={{
                    border: "1px solid #cbd5e1",
                    background: "#fff",
                    color: "#475569",
                    padding: "8px 20px",
                    borderRadius: "8px",
                    fontWeight: "600",
                    fontSize: "13px",
                    cursor: "pointer",
                    transition: "all 0.2s",
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.background = "#f8fafc";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.background = "#fff";
                  }}
                >
                  {tests[currentTestIndex]?.isPublished ? "Close" : "Cancel"}
                </button>
                <button
                  onClick={async () => {
                    localStorage.setItem("omrAnswers", JSON.stringify(answers));

                    const currentTest = tests[currentTestIndex];
                    if (currentTest?.isPublished) {
                      setLoading(true);
                      try {
                        const answersArray = Object.entries(answers)
                          .filter(([_, value]) => value)
                          .map(([questionNumber, correctAnswer]) => ({
                            questionNumber: parseInt(questionNumber),
                            correctAnswer,
                          }));

                        const questionPdfUrl = currentTest.questionPdf?.url || "";

                        const batchData = {
                          Institution_id: Institutionprofile._id,
                          examType: activeExam.value,
                          testFees: parseInt(formData.testFees) || 0,
                          testBatchName: formData.testBatchName || "",
                          schedulePdf: formData?.schedulePdf?.url || "",
                          testNo: parseInt(currentTest.testNo),
                          totalQuestions: parseInt(currentTest.totalQuestions || lastUpdatedQuestions || 0) || 0,
                          numberofTests: numberOfTesting,
                          isPublished: true,
                          questionFiles: {
                            questionPdf: questionPdfUrl,
                            answerPdf: formData?.answerPdf?.url || "",
                            videoLink: currentTest.videoLink || "",
                            answers: answersArray,
                            omrsheet: currentTest.omrsheet?.url || "",
                          },
                        };

                        const response = await putWithTokenAPI(
                          token,
                          `/batch/update/${currentTest._id}`,
                          batchData
                        );

                        if (response?.statusCode === 200 || response?.statusCode === 201) {
                          SafeToast.success("Answers updated successfully!");
                          await fetchBatchList();
                        } else {
                          SafeToast.error("Failed to update answers on server");
                        }
                      } catch (err) {
                        console.error(err);
                        SafeToast.error("Error updating answers");
                      } finally {
                        setLoading(false);
                      }
                    } else {
                      const answersArray = Object.entries(answers)
                        .filter(([_, value]) => value)
                        .map(([questionNumber, correctAnswer]) => ({
                          questionNumber: parseInt(questionNumber),
                          correctAnswer,
                        }));
                      setTests((prev) =>
                        prev.map((t, idx) =>
                          idx === currentTestIndex ? { ...t, answers: answersArray } : t
                        )
                      );
                      SafeToast.success("Answers configured locally!");
                    }

                    setOmrDialogOpen(false);
                  }}
                  style={{
                    border: "none",
                    background: "#2563eb",
                    color: "#fff",
                    padding: "8px 24px",
                    borderRadius: "8px",
                    fontWeight: "600",
                    fontSize: "13px",
                    cursor: "pointer",
                    boxShadow: "0 4px 6px -1px rgba(37, 99, 235, 0.2)",
                    transition: "all 0.2s",
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.background = "#1d4ed8";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.background = "#2563eb";
                  }}
                >
                  Save Answers
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Delete Test Batch Confirmation Dialog */}
      {showDeleteBatchModal && (
        <div
          className="modal-overlay"
          onClick={(e) => {
            if (e.target === e.currentTarget && !isDeletingBatch) {
              setShowDeleteBatchModal(false);
            }
          }}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(15, 23, 42, 0.5)",
            backdropFilter: "blur(4px)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 99999,
            padding: "20px",
          }}
        >
          <div
            style={{
              background: "#ffffff",
              borderRadius: "16px",
              width: "100%",
              maxWidth: "500px",
              boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
              overflow: "hidden",
              border: "1px solid #f1f5f9",
            }}
          >
            {/* Modal Header */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "20px 24px 16px",
                borderBottom: "1px solid #f1f5f9",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <div
                  style={{
                    width: "36px",
                    height: "36px",
                    borderRadius: "50%",
                    background: "#fee2e2",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#dc2626",
                  }}
                >
                  <Trash2 size={20} />
                </div>
                <h3 style={{ margin: 0, fontSize: "18px", fontWeight: "600", color: "#0f172a" }}>
                  Delete Test Batch
                </h3>
              </div>
              <button
                type="button"
                onClick={() => !isDeletingBatch && setShowDeleteBatchModal(false)}
                disabled={isDeletingBatch}
                style={{
                  background: "transparent",
                  border: "none",
                  cursor: isDeletingBatch ? "not-allowed" : "pointer",
                  color: "#94a3b8",
                  padding: "4px",
                  borderRadius: "6px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <X size={20} />
              </button>
            </div>

            {/* Modal Body */}
            <div style={{ padding: "20px 24px" }}>
              <p
                style={{
                  margin: "0 0 12px",
                  fontSize: "15px",
                  fontWeight: "600",
                  color: "#1e293b",
                  lineHeight: "1.5",
                }}
              >
                Are you sure you want to delete this test batch and its associated tests permanently?
              </p>
              <div
                style={{
                  padding: "12px 14px",
                  background: "#fff1f2",
                  borderRadius: "8px",
                  border: "1px solid #ffe4e6",
                  fontSize: "13px",
                  color: "#be123c",
                  lineHeight: "1.5",
                }}
              >
                Batch: <strong>{formData.testBatchName}</strong>
                <br />
                This action cannot be undone. All tests, question papers, answer keys, and schedules in this batch will be permanently removed.
              </div>
            </div>

            {/* Modal Footer */}
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "12px",
                padding: "16px 24px 20px",
                borderTop: "1px solid #f1f5f9",
                background: "#f8fafc",
              }}
            >
              <button
                type="button"
                disabled={isDeletingBatch}
                onClick={() => setShowDeleteBatchModal(false)}
                style={{
                  padding: "10px 18px",
                  borderRadius: "8px",
                  border: "1px solid #cbd5e1",
                  background: "#ffffff",
                  color: "#475569",
                  fontWeight: "500",
                  fontSize: "14px",
                  cursor: isDeletingBatch ? "not-allowed" : "pointer",
                }}
              >
                Cancel
              </button>
              <button
                type="button"
                disabled={isDeletingBatch}
                onClick={handleDeleteBatch}
                style={{
                  padding: "10px 20px",
                  borderRadius: "8px",
                  border: "none",
                  background: isDeletingBatch ? "#fca5a5" : "#dc2626",
                  color: "#ffffff",
                  fontWeight: "600",
                  fontSize: "14px",
                  cursor: isDeletingBatch ? "not-allowed" : "pointer",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                {isDeletingBatch ? "Deleting..." : "Delete Permanently"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Warning Alert Modal: Increasing Number of Tests */}
      {showIncreaseTestModal && (
        <div
          className="modal-overlay"
          onClick={(e) => {
            if (e.target === e.currentTarget && !loading) {
              setNumberOfTesting(pendingTestCountData?.existingCount || numberOfTesting);
              setShowIncreaseTestModal(false);
              setPendingTestCountData(null);
            }
          }}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(15, 23, 42, 0.5)",
            backdropFilter: "blur(4px)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 99999,
            padding: "20px",
          }}
        >
          <div
            style={{
              background: "#ffffff",
              borderRadius: "16px",
              width: "100%",
              maxWidth: "520px",
              boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
              overflow: "hidden",
              border: "1px solid #f1f5f9",
            }}
          >
            {/* Modal Header */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "20px 24px 16px",
                borderBottom: "1px solid #f1f5f9",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <div
                  style={{
                    width: "36px",
                    height: "36px",
                    borderRadius: "50%",
                    background: "#fef3c7",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#d97706",
                  }}
                >
                  <AlertTriangle size={20} />
                </div>
                <h3 style={{ margin: 0, fontSize: "18px", fontWeight: "600", color: "#0f172a" }}>
                  Test Batch Warning
                </h3>
              </div>
              <button
                type="button"
                onClick={() => {
                  setNumberOfTesting(pendingTestCountData?.existingCount || numberOfTesting);
                  setShowIncreaseTestModal(false);
                  setPendingTestCountData(null);
                }}
                disabled={loading}
                style={{
                  background: "transparent",
                  border: "none",
                  cursor: loading ? "not-allowed" : "pointer",
                  color: "#94a3b8",
                  padding: "4px",
                  borderRadius: "6px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <X size={20} />
              </button>
            </div>

            {/* Modal Body */}
            <div style={{ padding: "20px 24px" }}>
              <p
                style={{
                  margin: "0 0 14px",
                  fontSize: "15px",
                  fontWeight: "600",
                  color: "#92400e",
                  lineHeight: "1.5",
                }}
              >
                Warning: Increasing the number of tests will be treated as creating a New Test Batch, and additional platform fees will apply. Do you want to proceed?
              </p>
              <div
                style={{
                  padding: "12px 14px",
                  background: "#fffbeb",
                  borderRadius: "8px",
                  border: "1px solid #fef3c7",
                  fontSize: "13px",
                  color: "#78350f",
                  lineHeight: "1.5",
                }}
              >
                Existing Tests: <strong>{pendingTestCountData?.existingCount}</strong> &rarr; New Test Count: <strong>{pendingTestCountData?.count}</strong>
                <br />
                Creating extra tests beyond the original schedule incurs additional platform charges.
              </div>
            </div>

            {/* Modal Footer */}
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "12px",
                padding: "16px 24px 20px",
                borderTop: "1px solid #f1f5f9",
                background: "#f8fafc",
              }}
            >
              <button
                type="button"
                disabled={loading}
                onClick={() => {
                  setNumberOfTesting(pendingTestCountData?.existingCount || numberOfTesting);
                  setShowIncreaseTestModal(false);
                  setPendingTestCountData(null);
                }}
                style={{
                  padding: "10px 18px",
                  borderRadius: "8px",
                  border: "1px solid #cbd5e1",
                  background: "#ffffff",
                  color: "#475569",
                  fontWeight: "500",
                  fontSize: "14px",
                  cursor: loading ? "not-allowed" : "pointer",
                }}
              >
                Cancel
              </button>
              <button
                type="button"
                disabled={loading}
                onClick={() => {
                  setShowIncreaseTestModal(false);
                  setPendingTestCountData(null);
                  handleCreateExamBatch(true);
                }}
                style={{
                  padding: "10px 20px",
                  borderRadius: "8px",
                  border: "none",
                  background: "#d97706",
                  color: "#ffffff",
                  fontWeight: "600",
                  fontSize: "14px",
                  cursor: loading ? "not-allowed" : "pointer",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                {loading ? "Processing..." : "Proceed & Create"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UploadPage;
